module.exports = __webpack_public_path__ + "static/img/shangpin_moren@2x.3c144ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shangpin_moren@2x.png
// module id = 469
// module chunks = 1